import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-petition-details',
		path: '/admin/p/:slug',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-petition-details" */ './index'), {
			exportName: 'AdminPetitionDetails',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['support', 'campaigns', 'product', 'engineering'],
		},
		frame: {
			header: true,
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
		},
	},
];
